import React from "react";
import ReactDOM from "react-dom";
import App from "App";
// import { register } from "register-service-worker";
import "App.css";


ReactDOM.render(<App />, document.getElementById("root"));
// register();



// WEBPACK FOOTER //
// ./src/index.js